import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import styles from './TeamPhotoFeed.module.scss'

export default function TeamPhotoFeed(props) {
  const { teamFeedSubheading, teamFeedheading, teamFeedDescription, teamHeadshots } = props.fields
  const centered = props.centered === true

  const [scrollPosition, setScrollPosition] = useState(0)
  const imagesContainerRef = useRef(null)

  useEffect(() => {
    let scrollInterval

    // Continuous scroll logic
    scrollInterval = setInterval(() => {
      setScrollPosition((prevPosition) => {
        const containerWidth = imagesContainerRef.current.scrollWidth / 2
        return prevPosition <= -containerWidth ? 0 : prevPosition - 1
      })
    }, 20) // Adjust the speed of scroll
    return () => {
      if (scrollInterval) clearInterval(scrollInterval)
    }
  }, [])

  return (
    <>
      <div className={styles.teamPhotoFeed}>
        <div className={styles.teamPhotoFeedWrapper}>
          {/* Repeater image Field */}
          <div className={styles.imagesContent}>
            <div
              className={styles.imagesContentWrapper}
              style={{
                transform: `translateX(${scrollPosition}px)`
              }}
              ref={imagesContainerRef}
            >
              {/* Duplicate the images to enable seamless scrolling */}
              {teamHeadshots.concat(teamHeadshots).map((headshot, index) => (
                <Image
                  className={styles.headshot}
                  key={index}
                  src={headshot?.headshot?.node.sourceUrl}
                  alt={`Team member ${index + 1}`}
                  width={300}
                  height={300}
                />
              ))}
            </div>
          </div>

          <div className={`${styles.teamPhotoFeedMainContent} ${centered ? styles.contentCentered : ''}`}>
            <p className={styles.subheading}>{teamFeedSubheading}</p>
            <h3 className={styles.heading}>{teamFeedheading}</h3>
            <div className={styles.WYSIWYGWrapper}>
              <div className={styles.WYSIWYG} dangerouslySetInnerHTML={{ __html: teamFeedDescription }}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
